<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" @keydown.native.enter="$emit('search', formInline)">
      <el-form-item label="批次包编码">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="包编码" @change="$emit('search', formInline)"></el-input>
      </el-form-item>
      <el-form-item label="入库时间">
        <el-date-picker
            v-model="date"
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "From",
  data() {
    return {
      formInline: {},
      date:null
    }
  },
  mounted() {
    this.$emit('search', this.formInline)
  },
  methods: {
    dateChange: function (date) {
      console.log(date)
      if (!date) {
        this.date = null
        this.formInline.createTimeBegin = undefined
        this.formInline.createTimeEnd = undefined
        console.log(this.formInline)
        return
      }
      this.formInline.createTimeBegin = date[0];
      this.formInline.createTimeEnd = date[1];
    },
    rest: function () {
      this.formInline = {}
      this.date = null;
      this.$emit('search', this.formInline)
    }
  }
}
</script>

<style scoped>

</style>